module.exports = __webpack_public_path__ + "static/media/YB5M18_1.1c59cb8c.jpg";